export default __webpack_public_path__ + "images/64_1_image.jpg";